<template>
  <ComponentsLayoutWithNavbar
    id="check-tender-winner"
    main_color="var(--color-main-green)">
    <template #breadcrumbs>
      <TenderBreadcrumbs
        :current="current_bread"
        :parent_bread="parent_bread"/>
    </template>
    <template #main_content>
      <template v-if="loading">
        <v-skeleton-loader
          :boilerplate="true"
          class="mt-10 pr-8"
          :tile="true"
          type="heading"
          width="100%"/>
        <v-skeleton-loader
          :boilerplate="true"
          class="mt-3 pr-8"
          :tile="true"
          type="sentences"
          width="100%"/>
        <v-skeleton-loader
          :boilerplate="true"
          class="mt-4 main__green mt-5"
          :tile="true"
          type=" table-thead, table-tbody"
          width="100%"/>
      </template>
      <div
        v-else
        class="pt-4 width-100">
        <div class="flex flex-between">
          <div>
            <div class="h1-headline">
              {{ current_bread }}
            </div>
            <div class="h6-text pt-4 pb-2 text-left">
              #{{ tender ? tender.tenderNumber + ' ' + tender.title :'–' }}
            </div>
            <div class="text-start h8-text">
              {{ tender && tender.category ? tender.category.code + ' ' + tender.category.title :'–' }}
            </div>
          </div>
          <TenderFinished
            v-if="!has_required_agreement"
            :close="() => $store.commit('setTender' , {})"
            :tender="tender"
            :text="$route.params.reason"/>
          <CreateTenderDialog
            v-else
            :tender="tender"/>
        </div>
        <OffersGroups
          ref="offers_table"
          :bid_groups="bid_groups"
          :bids.sync="items"
          class="mt-4"
          :critery-card="criteryCard"
          show_selected_quantity
          :tender="tender"
          :with_header="is_prequalification"
          without_select/>
      </div>
    </template>
    <template #nav_bar="{ mini }">
      <div
        v-show="!mini"
        class="tender-info">
        <div class="pl-2 tender-info-card">
          <template v-if="loading">
            <v-skeleton-loader
              class="mt-10 px-8"
              height="50px"
              type="heading"
              width="80%"/>
            <v-skeleton-loader
              v-for="(i, n) in new Array(3)"
              :key="n"
              class="mt-3 px-8"
              height="50px"
              type="sentences"
              width="100%"/>
          </template>
          <template v-else>
            <InfoBar
              v-if="tender"
              :tender="tender"/>
          </template>
        </div>
        <BackToTenderBtn
          class="mx-auto"
          :tender-id="tender.tenderId"/>
      </div>
    </template>
  </ComponentsLayoutWithNavbar>
</template>

<script>
import InfoBar from 'components/tenders/tender page/InfoBar.vue'
import BackToTenderBtn from 'components/tenders/BackToTenderBtn.vue'
import TenderBreadcrumbs from 'components/tenders/TenderBreadcrumbs.vue'
import OffersGroups from 'components/tenders/tender page/OffersGroups.vue'
import TenderFinished from 'components/tenders/dialogs/TenderFinished.vue'
import CreateTenderDialog from 'components/tenders/dialogs/CreateTenderDialog.vue'
import ComponentsLayoutWithNavbar from 'pages/templates/ComponentsLayoutWithNavbar.vue'

import { filterSortMixin, modalMixin, tenderMixin } from 'mixins'

export default {
  name: 'checkWinner',
  mixins: [ filterSortMixin, modalMixin, tenderMixin ],
  data() {
    return {
      item: {},
      tender: {},
      loading: false,
      expanded: [],
      selected: [],
      criteryCard: null,
      currencies: []
    }
  },
  props: {
    // elements: Object,
  },
  async created() {
    await this.$store.dispatch('setCurrencies')
      .then((result) => {
        this.currencies = result
      })
    await this.getItem()
  },
  computed: {
    bid_groups() {
      let status = this.tender.tenderStatus,
        groups = this.getGroups(this.items, (item) => {
          if ( status?.id == 3 ) { return false }
          return item?.prequalification?.status
        } , null, null, true )

      groups.forEach(gr => {
        gr.winners = true
        if ( status?.id == 3 ) {
          gr.formatHeaders = (headers) => {
            headers[3].text = this.$t('Tenders.SelectedQuantity')
            return headers
          }
          gr.title = ''
        } else {
          gr.id = gr.title
          gr.title = this.$t('Tenders.prequalified.' + gr.title)
        }
      })
      if ( status?.id == 5 ) {
        groups = groups.sort(a => {
          return a.id == 'ACTIVE' ? -1 : 1
        })
      }
      return groups
    },
    parent_bread() {
      return this.item ? {
        text: this.item.title || '–',
        to: {name: 'offersForLot',
          params: { tenderId: this.$route.params.tenderId, lotId: this.$route.params.lotId, org: this.$route.params.org}}
      } : null
    },
    current_bread() {
      return this.is_prequalification ? this.$t('Tenders.CheckQualificationInformation') : this.$t('Tenders.CheckWinner')
    },
    tender_budjet() {
      if ( !this.tender || !this.tender?.lots ) { return '' }
      return this.tender?.lots.reduce( (total, tender ) => {
        return total += tender.quantity * tender.startAmount
      }, 0)
    },
    items() {
      if ( !this.tender || !this.tender.bids) { return [] }

      let type = this.$route.name
      let bids = this.getBids(this.tender?.bids, this.tender).filter(el => (type == 'checkWinner' ? el.selectedBid : true) && el.bidStatus == 'ACTIVE')
      return bids
    },
    is_prequalification() {
      return this.tender?.tenderStatus?.id == 5
    },
  },
  methods: {
    findLot(id) {
      return this.tender.lots.find(lot => lot.lotId == id)?.title
    },
    back() {
      this.$router.go(-1)
    },
    async getItem() {
      this.loading = true
      await this.$store.dispatch('getTenderItem', {id: this.$route.params.tenderId })
        .then(res => {
          this.tender = res
          let status = this.tender.tenderStatus
          if ( (this.$route.name == 'checkWinner' && (status?.id != 3 || !this.tender.bids.some(bid => bid.bidDetails.some(det => det.selectedBid)) ) )
            || (this.$route.name == 'checkPreQualification' && (status?.id != 5 || this.tender.bids.some(bid => bid.bidDetails.some(det => det?.prequalification?.status == 'PENDING' ))) ) ) {
            this.$router.push({name: 'tenderitem', params: { id: this.tender.tenderId, org: this.$route.params.org}})
            return
          }
          this.item = this.$route.params.lotId ? this.tender?.lots.find( lot => {
            return lot.lotId ==  +this.$route.params.lotId
          }) : null
        })
        .catch(res => this.$log_error(res))
      await this.$store.dispatch('infoAboutCriterionCard', {save: true, id: this.tender.criteriaCard}).then(res => this.criteryCard = res)
      this.loading = false
    },
  },
  components: {
    InfoBar,
    OffersGroups,
    TenderFinished,
    BackToTenderBtn,
    TenderBreadcrumbs,
    CreateTenderDialog,
    ComponentsLayoutWithNavbar
  }
}
</script>
<style lang="scss">
.v-skeleton-loader__table-thead,.v-skeleton-loader__table-tbody  {
  background: none !important;
  padding: 0;
}
</style>
<style lang="scss" scoped>
.tender-info-card.v-card.main__light_green {
  height: calc(100vh - 50px);
  overflow-y: auto;
}
.nav-actions {
  // position: absolute;
  height: 80px;
  max-height: 70px;
  bottom: 0;
  width: 100%;
  background-color: var(--white-color);
  z-index: 20;
}
</style>
